<template>
  <y-shelf :title="t_data.base.title">
    <div slot="content" class="floors">
      <mall-goods 
			:msg="item" 
			v-for="(item,j) in t_data.data" 
			:key="j" 
			:showBtn=showBtn
			:usage=usage
            :showBrief="showBrief"
            >
      </mall-goods>
    </div>
  </y-shelf>
</template>
<script>
import YShelf from '/components/shelf'
import mallGoods from '/components/mallGoods'
export default {
  name: 'goodsGrid',
  props: {
    data: {
      type: Object
    },
    usage: {
      type: String
    },
  },
  data () {
    return {
        showBrief:false //是否展示副标题
    }
  },
  computed: {
    t_data () {
      let tmp = this.data
      tmp.data = tmp.data.map(v => { return {...v, item_name: v.title, item_id: v.goodsId, pics: [v.imgUrl]} }
      )
      // console.log(tmp)
      return tmp
    },
    showBtn () {
      return this.usage !== 'store'
    }
  },
  components: {
    YShelf,
    mallGoods
  }
}
</script>
<style lang="scss" scoped>
@mixin wh($w,$h:$w) {
  width: $w;
  height: $h;
}
%block-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
  .gray-box {
    position: relative;
    margin-bottom: 30px;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #dcdcdc;
    border-color: rgba(0, 0, 0, .14);
    box-shadow: 0 3px 8px -6px rgba(0, 0, 0, .1);
    .title {
      padding-left: 30px;
      position: relative;
      z-index: 10;
      height: 60px;
      padding: 0 10px 0 24px;
      border-bottom: 1px solid #d4d4d4;
      border-radius: 8px 8px 0 0;
      box-shadow: rgba(0, 0, 0, .06) 0 1px 7px;
      background: #f3f3f3;
      background: -webkit-linear-gradient(#fbfbfb, #ececec);
      background: linear-gradient(#fbfbfb, #ececec);
      line-height: 60px;
      font-size: 18px;
      color: #333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h2 {
        font-size: 18px;
        font-weight: 400;
        color: #626262;
        display: inline-block;
      }
    }
  }
  .floors {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .imgbanner {
      width: 50%;
      height: 430px; 
      .cover-link {
        cursor: pointer;
        display: block;
        position: absolute;
        top: 60px;
        left: 0;
        width: 50%;
        height: 430px; 
        z-index: 4;
        background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
      }
      .cover-link:hover {
        box-shadow: inset 0 0 38px rgba(0,0,0,.08);
        transition: all .15s ease;
      }
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .good-item {
    background: #fff;
    width: 25%;
    transition: all .5s;
    height: 430px;
/*    &:hover {
      transform: translateY(-3px);
      box-shadow: 1px 1px 20px #999;
      .good-price p {
        display: none;
      }
      .ds {
        display: flex;
      }
    }*/
    .ds {
      @extend %block-center;
      width: 100%;

    }

    .good-img {
      img {
        margin: 50px auto 10px;
        @include wh(206px);
        display: block;
      }
    }
    .good-price {
      margin: 15px 0;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #d44d44;
      font-family: Arial;
      font-size: 18px;
      font-weight: 700;
    }
    .good-title {
      line-height: 1.2;
      font-size: 16px;
      color: #424242;
      margin: 0 auto;
      padding: 0 14px;
      text-align: center;
      overflow: hidden;
    }
    h3 {
      text-align: center;
      line-height: 1.2;
      font-size: 12px;
      color: #d0d0d0;
      padding: 10px;
    }

  }
</style>




// WEBPACK FOOTER //
// goodsGrid.vue?32ebf90b